import type { TShowRoleAssignment } from '@schemas'

export type StaffRole = TShowRoleAssignment['role']

export const STAFF_ROLE_ORDER: StaffRole[] = [
  'organizer',
  'presiding_judge',
  'lead_secretary',
  'secretary',
  'steward',
  'judge',
  'viewer',
]

export const STAFF_ROLE_LABELS: Record<StaffRole, { singular: string; plural: string }> = {
  organizer: { singular: 'Organizer', plural: 'Organizers' },
  presiding_judge: { singular: 'Presiding Judge', plural: 'Presiding Judges' },
  lead_secretary: { singular: 'Lead Secretary', plural: 'Lead Secretaries' },
  secretary: { singular: 'Secretary', plural: 'Secretaries' },
  steward: { singular: 'Steward', plural: 'Stewards' },
  judge: { singular: 'Judge', plural: 'Judges' },
  viewer: { singular: 'Viewer', plural: 'Viewers' },
}
